<template>
  <v-dialog
      v-model="show"
      fullscreen
  >
    <v-card style="width:100%; height: 100%; overflow-y: auto">
      <!-- AppBar de la venta -->
      <v-toolbar
          dark
          color="primary"
      >
        <v-btn
            icon
            dark
            @click="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <FichaClienteComponent
          :id_cliente="id_cliente"
          :show_app_bar="false"
          :show_tab_agenda="false" />
    </v-card>
  </v-dialog>
</template>


<script>
import rules from "@/rules";

export default {
  name: 'DialogFichaCliente',
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  props: ['value', 'id_cliente'],
  components: {
    FichaClienteComponent: () => import('@/views/Clientes/FichaCliente')
  }
}
</script>
